module.exports = __webpack_public_path__ + "media/bootstrap-icons/shift-8c6d0783.svg";